import { use } from "react";
import { AuthContext } from "@/context/AuthContext";
import { getAuthService } from "@/services/user-auth/auth-factory";
import type { AuthService } from "@/services/user-auth/auth-service";

export function useAuthService(): AuthService {
	const authContext = use(AuthContext);

	return getAuthService(authContext?.roles || null);
}
